import { Mail, Phone, Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { LOGO_URL, INSTAGRAM_URL, FACEBOOK_URL, CONTACT_EMAIL, CONTACT_PHONE } from "@/lib/brand";

const BANK_LINKS = [
  { slug: "hdfc-personal-loan", name: "HDFC Personal Loan" },
  { slug: "icici-personal-loan", name: "ICICI Personal Loan" },
  { slug: "sbi-xpress-credit-personal-loan", name: "SBI Xpress Credit" },
  { slug: "axis-personal-loan", name: "Axis Personal Loan" },
  { slug: "kotak-personal-loan", name: "Kotak Personal Loan" },
  { slug: "bajaj-finserv-personal-loan", name: "Bajaj Finserv" },
];

export const Footer = () => (
  <footer className="bg-slate-900 text-slate-300">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="bg-white inline-block rounded-lg p-3">
            <img src={LOGO_URL} alt="Loan81" className="h-12 w-auto object-contain" />
          </div>
          <p className="mt-5 text-sm leading-relaxed max-w-md">
            India's honest personal loan comparison platform. Compare and choose loans from 15+ RBI-registered banks and NBFCs — always free, never salesy.
          </p>

          <div className="mt-6 space-y-2">
            <a href={`tel:${CONTACT_PHONE}`} data-testid="footer-phone" className="flex items-center gap-2 text-sm hover:text-emerald-400 transition-colors">
              <Phone className="w-4 h-4" /> {CONTACT_PHONE}
            </a>
            <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="flex items-center gap-2 text-sm hover:text-emerald-400 transition-colors">
              <Mail className="w-4 h-4" /> {CONTACT_EMAIL}
            </a>
          </div>

          <div className="mt-6 flex items-center gap-2">
            <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="footer-instagram"
               aria-label="Instagram"
               className="w-10 h-10 rounded-lg bg-slate-800 hover:bg-emerald-500 flex items-center justify-center transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a href={FACEBOOK_URL} target="_blank" rel="noreferrer" data-testid="footer-facebook"
               aria-label="Facebook"
               className="w-10 h-10 rounded-lg bg-slate-800 hover:bg-emerald-500 flex items-center justify-center transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="lg:col-span-2">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-400 mb-4">Product</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#compare" className="hover:text-white">Compare Loans</a></li>
            <li><a href="/#emi" className="hover:text-white">EMI Calculator</a></li>
            <li><a href="/#faq" className="hover:text-white">FAQs</a></li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-400 mb-4">Top Lenders</div>
          <ul className="space-y-2 text-sm">
            {BANK_LINKS.map((b) => (
              <li key={b.slug}>
                <Link to={`/loans/${b.slug}`} className="hover:text-white" data-testid={`footer-bank-${b.slug}`}>{b.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-400 mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/admin" data-testid="footer-admin-link" className="hover:text-white">Admin Dashboard</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-white">Terms of Use</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row justify-between gap-2 text-xs text-slate-500">
        <div>© {new Date().getFullYear()} Loan81. All rates and fees are indicative and change at lender discretion.</div>
        <div>Not a lender. RBI does not regulate loan comparison platforms.</div>
      </div>
    </div>
  </footer>
);
